import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';
import { UsuarioIntegradorModel } from '../../models/vmi-usuarioIntegrador';

@Injectable({
  providedIn: 'root'
})
export class VmiUsuIntegraService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.administracion;
  }

  getAll(): Observable<UsuarioIntegradorModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.integrador);
  }

  findClienteKosmos(login: string) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.integrador + `/${login}`);
  }

  create(innObj: UsuarioIntegradorModel): Observable<any> {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioUrl.integrador, innObj);
  }
  delete(idCLiente: number,usuarioksosmos:string): Observable<any> {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioUrl.integrador + `/${idCLiente}/${usuarioksosmos}`);
  }

}
